import React, { useContext } from "react";
import { AppContext } from "../../AppContext";
import { Button } from "react-bootstrap";
import { onboard } from "../../web3/web3";

interface Props {
  connectBtnText?: string;
}
export function ConnectMetaMask({ connectBtnText }: Props) {
  const ctx = useContext(AppContext);

  const connect = async () => {
    try {
      const res = await onboard(ctx.provider);
      ctx.setAccounts(res.accounts);
    } catch (err) {
      console.error(err);
      return;
    }
  };

  if (ctx.accounts) {
    return ctx.accounts[0];
  }

  return (
    <Button className="button metamask" onClick={connect}>
      {connectBtnText ?? "Connect MetaMask"}
    </Button>
  );
}
